<template>
    <div>
        <div class="bar"></div>
        <div class="tip">企业版的功能和权益将会不断扩充，首选推荐企业版四季度版本</div>
        <div class="white">
            <div class="whiteText1">您已确认企业版套件订单合同，请尽快完成付款</div>
            <div class="whiteText2">请在合同确认后的45天内完成付款</div>
            <div class="greyContent">
                <div class="greyText1">订单编号：</div>
                <div class="greyText2">{{ id }}</div>
                <div class="greyText1" style="top: 96px;">下单时间：</div>
                <div class="greyText2" style="top: 96px;">{{ time }}</div>
                <div class="greyText1" style="top: 146px;">套件版本：</div>
                <div class="greyText2" style="top: 146px;">{{suitVersion}}</div>
                <div class="greyText1" style="top: 196px;">订单价格：</div>
                <div class="greyText2" style="top: 196px;">￥ {{price}} </div>
                <div class="greyText1" style="top: 246px;">合同甲方名称：</div>
                <div class="greyText2" style="top: 246px;">{{contractName}}</div>
                <div class="greyButton1">查看合同</div>
                <div class="greyLine"></div>
                <div class="greyText1" style="top: 379px;">支付方式：</div>
                <div class="greyText2" style="top: 379px;">对公转账</div>
                <div class="greyText1" style="top: 429px;">发票形式：</div>
                <img src="~@/assets/newHome/未选中.png" alt="" class="greyIcon" v-if="invoice!=1" @click="invoiceSelect(1)">
                <img src="~@/assets/newHome/选中.png" alt="" class="greyIcon" v-if="invoice==1">
                <div class="greyText3">个人电子发票</div>
                <div class="greyText4">(默认)</div>
                <img src="~@/assets/newHome/未选中.png" alt="" class="greyIcon" v-if="invoice!=2" @click="invoiceSelect(2)" style="left: 487px;">
                <img src="~@/assets/newHome/选中.png" alt="" class="greyIcon" v-if="invoice==2"  style="left: 487px;">
                <div class="greyText3"  style="left: 516px;">企业普通电子发票</div>
                <img src="~@/assets/newHome/未选中.png" alt="" class="greyIcon" v-if="invoice!=3" @click="invoiceSelect(3)"  style="left: 777px;">
                <img src="~@/assets/newHome/选中.png" alt="" class="greyIcon" v-if="invoice==3"  style="left: 777px;">
                <div class="greyText3"  style="left: 806px;">企业增值税专用发票（纸质）</div>
                <div class="greyInvoice" :class="[invoice==2 ? 'greyInvoice1':'', invoice==3 ? 'greyInvoice2':'']">
                    <div class="qyInvoice" v-if="invoice==2">
                        <div class="qyText1">单位名称：</div>
                        <div class="greyInput">
                            <input type="text" class="inputContent" id="inputContentId" placeholder="" v-model="qyCompany"/>
                        </div>
                        <div class="qyText1" style="top: 65px;">纳税人识别号：</div>
                        <div class="greyInput" style="top: 55px;">
                            <input type="text" class="inputContent" id="inputContentId1" placeholder="" v-model="qyNumber"/>
                        </div>
                    </div>
                    <div class="zpInvoice" v-if="invoice==3">
                        <div class="qyText1">单位名称：</div>
                        <div class="greyInput">
                            <input type="text" class="inputContent" id="inputContentId" placeholder="" v-model="zpCompany"/>
                        </div>
                        <div class="qyText1" style="top: 65px;">纳税人识别号：</div>
                        <div class="greyInput" style="top: 55px;">
                            <input type="text" class="inputContent" id="inputContentId1" placeholder="" v-model="zpNumber"/>
                        </div>
                        <div class="zpLine"></div>
                        <div class="zpText1">资质信息</div>
                        <div class="qyText1" style="top: 175px;">注册地址：</div>
                        <div class="greyInput" style="top: 165px;">
                            <input type="text" class="inputContent" id="inputContentId2" placeholder="" v-model="address"/>
                        </div>
                        <div class="qyText1" style="top: 230px;">注册电话：</div>
                        <div class="greyInput" style="top: 220px;">
                            <input type="text" class="inputContent" id="inputContentId3" placeholder="" v-model="phone"/>
                        </div>
                        <div class="qyText1" style="top: 285px;">开户银行：</div>
                        <div class="greyInput" style="top: 275px;">
                            <input type="text" class="inputContent" id="inputContentId4" placeholder="" v-model="bank"/>
                        </div>
                        <div class="qyText1" style="top: 340px;">银行账号：</div>
                        <div class="greyInput" style="top: 330px;">
                            <input type="text" class="inputContent" id="inputContentId5" placeholder="" v-model="bankNumber"/>
                        </div>
                    </div>
                </div>
                <div class="greyWhite">
                  <div class="greyWhiteText1">对公转账流程</div>
                  <div class="greyWhiteText2">订单应付：￥ {{price}}</div>
                  <div class="greyWhiteText3">温馨提示：<br>
                    1、财务会在3个工作日内审核并查账，如到账将会在1小时之内对您的订单进行排产，受银行处理时间影响，付款 <br> 到账可能有所延误。<br>
                    2、如果线下汇款过程中遇到任何问题可随时联系商务经理
                  </div>
                  <div class="greyWhiteText4">打款至长光卫星技术股份有限公司指定收款账号</div>
                  <img src="~@/assets/newHome/1.png" alt="" class="shadowClose">
                  <img src="~@/assets/newHome/2.png" alt="" class="shadowClose" style="top: 579px;">
                  <img src="~@/assets/newHome/3.png" alt="" class="shadowClose" style="top: 700px;">

                  <div class="greyWhiteText5"><span style="color:#9B9B9B ;">转账途径</span> 银行柜台转账、网上银行</div>
                  <div class="greyWhiteText5" style="top: 370px;"><span style="color:#9B9B9B ;">收款户名</span> 长光卫星技术股份有限公司</div>
                  <div class="greyWhiteText5" style="top: 402px;"><span style="color:#9B9B9B ;">收款账号</span> 631326352</div>
                  <div class="greyWhiteText5" style="top: 434px;"><span style="color:#9B9B9B ;">开户行名称</span> 中国民生银行长春一汽支行</div>
                  <div class="greyWhiteText5" style="top: 466px;"><span style="color:#9B9B9B ;">开户行行号</span> 305241000033</div>
                  <div class="greyWhiteText5" style="top: 498px;"><span style="color:#9B9B9B ;">汇款备注</span> 订单号+吉林一号遥感商城账户(手机号)</div>
                  <div class="greyWhiteText6">请妥善保管汇款底单</div>
                  <div class="greyWhiteText4" style="top: 581px;">提交汇款信息</div>
                  <div class="greyWhiteText7">打款至长光卫星技术股份有限公司指定银行账号后，点击下方已完成汇款按钮，或联系<span style="color:#6699CC ;cursor: pointer;">商务经理</span>提交您的汇款信息</div>
                  <div class="greyWhiteText4" style="top: 702px;">汇款结果反馈</div>
                  <div class="greyWhiteText7" style="top: 749px;">确定打款操作后，可以在<span style="color:#6699CC ;cursor: pointer;">我的订单</span>页面查看生产进度</div>
                  <div class="greyWhiteLine1"></div>
                  <div class="greyWhiteLine1" style="top: 613px;height: 81px;"></div>
                </div>
                <div class="greyButton2" v-if="finish==0" @click="finishMoney()">已完成汇款</div>
                <div class="greyButton3" v-if="finish==1">等待商务经理确认</div>
            </div>
        </div>
        <div class="redTip" v-if="!canSubmit">请填写全部信息！</div>
    </div>
</template>

<script>
export default {
    name:"Payment",
    data(){
        return{
            id:"",
            contractName:"",
            time:"",
            suitVersion:"",
            invoice:1,
            price:"88,000.00",
            finish:0,
            qyCompany:"",
            qyNumber:"",
            zpCompany:"",
            zpNumber:"",
            address:"",
            phone:"",
            bank:"",
            bankNumber:"",
            canSubmit:true

        }
    },
    methods:{
        getKey() {
            return localStorage.getItem("token");
        },
        toPageTop(){
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        },
        invoiceSelect(i){
            this.invoice=i
            this.invoiceMessage()
        },
        //根据id查询订单信息
        getOrderData(){
            let id = this.$route.query.id;
            var inputForm = new FormData();
            inputForm.append("id",id);
            this.axios.post("/tilesapi/tiles/register/queryTileOrderById", inputForm, {
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
                })
                .then((res) => {
                if(res.data.code==200){
                    this.id = id
                    let data = res.data.data
                    this.time = data.createTime
                    if(data.repositorySubName=="2023年全年"){
                        this.suitVersion = "企业版-2023年四季度版"
                    }else if(data.repositorySubName=="2023第一季度"){
                        this.suitVersion = "企业版-单季度版-2023第一季度"
                    }else if(data.repositorySubName=="2023第二季度"){
                        this.suitVersion = "企业版-单季度版-2023第二季度"
                    }else if(data.repositorySubName=="2023第三季度"){
                        this.suitVersion = "企业版-单季度版-2023第三季度"
                    }else if(data.repositorySubName=="2023第四季度"){
                        this.suitVersion = "企业版-单季度版-2023第四季度"
                    }
                    this.price = data.payFinal
                    this.contractName = data.userClientName
                }
            });

        },
        //发票信息带入
        invoiceMessage(){
            this.axios
                    .post(
                        "/loginapi/invoice/queryUserDefaultInvoiceInfo",null,
                        {headers: {
                                Authorization: this.getKey(),
                            },}
                    )
                    .then((res) => {
                        let data = res.data.data
                        if(data!=''&&data!=null){
                            if(data.category==0){
                                this.qyCompany=data.company
                                this.qyNumber=data.identifyNumber
                            }else if(data.category==1){
                                this.zpCompany=data.company
                                this.zpNumber=data.identifyNumber
                                this.address=data.companyAddress
                                this.bank=data.bankName
                                this.phone=data.companyPhone
                                this.bankNumber=data.bankNumber

                            }
                        }
                    });
        },
        //确认汇款
        finishMoney(){
            this.canSubmit = true
            if(this.invoice==2){
                if(this.qyCompany==''||this.qyCompany==null||this.qyNumber==''||this.qyNumber==null){
                    this.canSubmit=false
                }
            }
            if(this.invoice==3){
                if(this.zpCompany==''||this.zpNumber==''||this.zpCompany==null||this.zpNumber==null||this.address==''||this.address==null||this.phone==''||this.phone==null||this.bank==''||this.bank==null||this.bankNumber==''||this.bankNumber==null){
                    this.canSubmit=false
                }
            }
            if(this.canSubmit){
                let invoiceType = "gr"
                if(this.invoice==1){
                    invoiceType="gr"
                }else if(this.invoice==2){
                    invoiceType="qy"
                }else if(this.invoice==3){
                    invoiceType="zp"
                }
                var userInfo = {
                    invoiceType: invoiceType,
                    orderId:"05d83fdb21b148148e4303b98e20c9c2"
                };
                this.axios.post("/tilesapi/tiles/pay/unionPay",userInfo, {
                    headers: {
                    Authorization: "Bearer " + this.getKey(),
                    },
                }).then((res)=>{
                   console.log(res)
                   this.finish=1
                })
            }
        }

    },
    mounted(){
        this.toPageTop()
        this.getOrderData()

    }

}
</script>

<style scoped>
.bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.tip{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #F5F5F6;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 76px;
    text-align: center;
}
.white{
    position: relative;
    width: 1280px;
    height:2300px;
    margin-left: calc(50% - 640px);
    background-color: #fff;

}
.whiteText1{
    position: absolute;
    top: 75px;
    width: 800px;
    left:calc(50% - 400px);
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}
.whiteText2{
    position: absolute;
    top: 142px;
    left:calc(50% - 400px);
    width: 800px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    text-align: center;
}
.greyContent{
    position: absolute;
    top: 214px;
    width: 1280px;
    height: auto;
    background-color: #f5f5f5;
    border-radius: 16px;
}
.greyText1{
    position: absolute;
    top: 46px;
    right: 1065px;
    width: 200px;
    height: 30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color:  #A8A8A8;
    line-height: 30px;
    text-align: right;
}
.greyText2{
    position: absolute;
    top: 46px;
    left: 225px;
    width: 768px;
    height: 30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color:  #A8A8A8;
    line-height: 30px;
}
.greyButton1{
    position: absolute;
    top: 236px;
    right: 52px;
    width: 128px;
height: 40px;
border-radius: 8px;
border: 1px solid #3A3A3A;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #3A3A3A;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.greyLine{
    position: absolute;
    top: 326px;
    left: calc(50% - 589px);
    width: 1178px;
    height: 1px;
    background: linear-gradient(
        to left,
        transparent 0%,
        transparent 50%,
        #979797 50%,
        #979797 100%
    );
    background-size: 10px 1px; /* 第一个参数控制虚线的间隙（利用的是图片的放大效果一样），第二个参数控制虚线的粗细 */
    background-repeat: repeat-x;
    background-position: top;
}
.greyIcon{
    position: absolute;
    width: 16px;
    height: 16px;
    top: 438px;
    left: 225px;
    cursor: pointer;
}
.greyText3{
    position: absolute;
    top: 435px;
    left: 253px;
    width: 210px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
}
.greyText4{
    position: absolute;
    top: 466px;
    left: 251px;
    width:40px;
height: 17px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #979797;
line-height: 17px;
}
.greyInvoice{
    position: relative;
    margin-top: 513px;
    margin-left: 52px;
    width: 1175px;
    height: 1px;
    /* background-color: plum; */
    overflow: hidden;
}
.greyInvoice1{
    position: relative;
    margin-top: 513px;
    margin-left: 52px;
    width: 1175px;
    height: 100px;
    /* background-color: plum; */
    overflow: hidden;
}
.greyInvoice2{
    position: relative;
    margin-top: 513px;
    margin-left: 52px;
    width: 1175px;
    height: 400px;
    /* background-color: plum; */
    overflow: hidden;
}
.qyInvoice{
    position: absolute;
    width: 1175px;
    height: 100px;
}
.zpInvoice{
    position: absolute;
    top: 0;
    left: 0;
    width: 1175px;
    height: 400px;
}
.qyText1{
    position: absolute;
    top: 10px;
    left: 240px;
    width: 200px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    text-align: right;
}
.greyInput{
    position: absolute;
    top: 0px;
    left: 445px;
    width: 380px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
}
.inputContent{
  position: absolute;
  top: 5px;
    left: 5px;
  width: 370px;
height: 30px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3a3a3a;
line-height: 30px;
position: absolute;
  border: none;
  background: none;
  outline: none;
  padding: 0;
}
.zpLine{
    position: absolute;
    top: 130px;
    left: 325px;
    width: 500px;
    height: 1px;
    border-bottom: 1px #979797 dashed;
}
.zpText1{
    position: absolute;
    top: 121px;
    left: 530px;
    width: 80px;
    height: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color:  #A8A8A8;
    line-height: 20px;
    text-align: center;
    background-color: #f5f5f5;
}
.greyWhite{
    position: relative;
    margin-top: 30px;
    margin-left: 52px;
    width: 1175px;
height: 820px;
background: #FFFFFF;
}
.greyWhiteText1{
    position: absolute;
    top: 38px;
    left: 84px;
    width: 800px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #4A4A4A;
line-height: 22px;
}
.greyWhiteText2{
position: absolute;
top: 80px;
left: 84px;
width: 800px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #979797;
line-height: 20px;
}
.greyWhiteText3{
    position: absolute;
    top: 149px;
    left: 84px;
    width: 710px;
    height: 98px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5A5A5A;
    line-height: 25px;
}
.greyWhiteText4{
    position: absolute;
    top: 291px;
    left: 123px;
    width: 800px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #5F5F5F;
line-height: 22px;
}
.shadowClose{
    position: absolute;
    top: 289px;
    left: 83px;
}
.greyWhiteText5{
    position: absolute;
    top: 338px;
    left: 123px;
    width: 800px;
    height: 17px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #5F5F5F;
line-height: 17px;

}
.greyWhiteText6{
    position: absolute;
    width: 800px;
    top: 530px;
    left: 123px;
    height: 17px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #F56161;
line-height: 17px;

}
.greyWhiteText7{
    position: absolute;
    width: 800px;
    top: 628px;
    left: 123px;
    height: 17px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #5F5F5F;
line-height: 17px;
}
.greyWhiteLine1{
    position: absolute;
    top: 323px;
    left: 95px;
    width: 0.5px;
height: 250px;
background-color:  #D8D8D8;
}
.greyButton2{
    margin-top: 100px;
    margin-left: 1078px;
    margin-bottom: 100px;
    width: 150px;
    height: 40px;
    background: #1E81EB;
    border-radius: 8px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
.greyButton3{
    margin-top: 100px;
    margin-left: 1078px;
    margin-bottom: 100px;
    width: 150px;
height: 40px;
background: #CCCCCC;
border-radius: 6px;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #FFFFFF;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.redTip{
position: fixed;
width: 800px;
height: 50px;
background: #FF6666;
box-shadow: 0px 0px 3px 0px rgba(0,0,0,0.5);
border-radius: 4px;
left: calc(50% - 400px);
top: 120px;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 50px;
text-shadow: 0px 0px 3px rgba(0,0,0,0.5);
text-align: center;
}
</style>
